import { render, staticRenderFns } from "./ProjectResponsibleForm.vue?vue&type=template&id=649542c9&scoped=true&"
import script from "./ProjectResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./ProjectResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649542c9",
  null
  
)

export default component.exports